<template>
    <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
    <div ref="contextMenu"
         v-if="menuVisible"
         v-bind:style="menuStyle"
         v-on:blur="closeMenu"
         class="fm-context-menu"
         tabindex="-1">
        <ul class="list-unstyled">
          <li @click="showModal('newFolder')">
            <i class="fa fa-folder"/>{{ $t('filemanager.menucontext.general.folder') }}
          </li>
          <li @click="showModal('Upload')">
            <i class="fa fa-upload"/>{{ $t('filemanager.menucontext.general.files') }}
          </li><hr>
          <li @click="refreshAll()">
            <i class="fa fa-sync"/>{{ $t('filemanager.menucontext.general.refresh') }}
          </li>
          <li @click="paste()">
            <i class="fa fa-paste"/>{{ $t('filemanager.menucontext.general.paste') }}
          </li><hr>
        </ul>
    </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import EventBus from '../eventBus';
import contextMenu from './mixins/contextMenu';
import contextMenuRules from './mixins/contextMenuRules';
import contextMenuActions from './mixins/contextMenuActions';

export default {
  name: 'GlobalContextMenu',
  mixins: [contextMenu, contextMenuRules, contextMenuActions],
  data() {
    return {
      menuVisible: false,
      menuStyle: {
        top: 0,
        left: 0,
      },
    };
  },
  mounted() {
    /**
     * Listen events
     * 'contextMenu'
     */
    EventBus.$on('GlobalContextMenu', (event) => this.showMenu(event));
  },
  computed: {
    /**
     * Context menu items
     * @returns {*}
     */
    menu() {
      return this.$store.state.settings.contextMenu;
    },
    breadcrumb() {
      return this.$store.getters[`${this.activeManager}/breadcrumb`];
    },
    activeManager() {
      return this.$store.state.activeManager;
    },
  },
  methods: {
    /**
     * Paste
     */
    paste() {
      this.$store.dispatch('paste');
      this.menuVisible = false;
    },

    /**
     * Show modal window
     * @param modalName
     */
    showModal(modalName) {
      // show selected modal
      this.$store.commit('modal/setModalState', {
        modalName,
        show: true,
      });
      this.menuVisible = false;
    },

    /**
     * Refresh file manager
     */
    refreshAll() {
      this.$store.dispatch('refreshAll');
      this.menuVisible = false;
    },

    /**
     * Show context menu
     * @param event
     */
    showMenu(event) {
        this.menuVisible = true;
  
        // focus on menu
        this.$nextTick(() => {
          this.$refs.contextMenu.focus();
          // set menu params
          this.setMenu(event.pageY, event.pageX);
        });
    },

    /**
     * Set context menu coordinates
     * @param top
     * @param left
     */
    setMenu(top, left) {
      // get parent el (.fm-body)
      const el = this.$refs.contextMenu.parentNode;

      // get parent el size
      const elSize = el.getBoundingClientRect();

      // actual coordinates of the block
      const elY = window.pageYOffset + elSize.top;
      const elX = window.pageXOffset + elSize.left;

      // calculate the preliminary coordinates
      let menuY = top - elY;
      let menuX = left - elX;

      // calculate max X and Y coordinates
      const maxY = elY + (el.offsetHeight - this.$refs.contextMenu.offsetHeight - 25);
      const maxX = elX + (el.offsetWidth - this.$refs.contextMenu.offsetWidth - 25);

      if (top > maxY) menuY = maxY - elY;
      if (left > maxX) menuX = maxX - elX;

      // set coordinates
      this.menuStyle.top = `${menuY}px`;
      this.menuStyle.left = `${menuX}px`;
    },

    /**
     * Close context menu
     */
    closeMenu() {
      this.menuVisible = false;
    },

    /**
     * Show context menu item
     * @param name
     * @returns {*}
     */
    showMenuItem(name) { 
      if (Object.prototype.hasOwnProperty.call(this, `${name}Rule`)) {
        if (name == "fileLocation") {
          if (this.breadcrumb === null || this.breadcrumb[0] !== "searchResult") {
            return false;
          }
        }
        return this[`${name}Rule`]();
      }

      return false;
    },

    /**
     * Call actions when clicking the context menu
     * @param name
     */
    menuAction(name) {
      if (Object.prototype.hasOwnProperty.call(this, `${name}Action`)) {
        this[`${name}Action`]();
      }
      // close context menu
      this.closeMenu();
    },
  },
};
</script>

<style lang="scss">
    .fm-context-menu {
        position: absolute;
        width: 200px;
        z-index: 9997;
        background-color: white;
        box-shadow: 0 1rem 3rem rgb(0 0 0 / 18%);
        border-radius: 6px;
        color: rgb(43, 45, 48);
        padding-top: 10px;
        padding-bottom: 10px;

        &:focus {
          outline: none;
        }

        .list-unstyled {
          margin-bottom: 0;
        }

        ul > li {
          padding: 8px;
          margin-top: 8px;
          margin-bottom: 8px;
          color: rgb(48, 56, 71);
        }

        ul > li:not(.disabled) {
            cursor: pointer;

            &:hover {
                background-color: #f6f8fc;
                color: rgb(44, 42, 42);
                padding: 8px;
                margin-top: 8px;
                margin-bottom: 8px;
            }

            i {
                padding-left: 4px;
                padding-right: 2rem;
            }
        }
    }
</style>
